"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;





























































































































var _user = require("@/utils/user");
var _formatter = require("@/utils/formatter"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { tableData: [], // 列表数据
      organizationList: [], robotId: '', insId: '', newadd: false, modOrg: false, title: '', searchData: { name: '', merchant: '', voicePlatform: '', page: 1, // 页码条数
        rows: 10 }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, addData: { id: '', merchant: '', name: '', remark: '', voicePlatform: '' }, rules: { voicePlatform: [{ required: true, message: '请输入平台编码', trigger: 'blur' }], name: [{ required: true, message: '请输入语音应用', trigger: 'blur' }], merchant: [{ required: true, message: '请输入应用编码', trigger: 'blur' }] }, // 表格列
      tableColumns: [{ prop: 'voicePlatform', label: '平台编码', isShow: true }, { prop: 'name', label: '语音应用', isShow: true }, { prop: 'merchant', label: '应用编码', isShow: true }, { prop: 'remark', label: '备注', isShow: true }, { prop: 'createTime', label: '创建时间', formatter: _formatter.dateFormatter, isShow: true }, { prop: 'updateTime', label: '更新时间', formatter: _formatter.dateFormatter, isShow: true }], defaultProps: { children: 'child', label: 'insName' } };}, mounted: function mounted() {var self = this;self.init();}, methods: { init: function init() {var self = this;self.getData('/api/voiceApp', self.searchData, function (res) {self.tableData = res.list;self.pageData.page = res.pageNum;self.pageData.total = res.total;});}, getOrganziationList: function getOrganziationList() {var self = this;self.getData('/api/institution/dropList/0', {}, function (res) {self.organizationList = res;});}, checkPermission: _user.checkPermission, resetFun: function resetFun() {// 重置
      this.searchData.merchant = '';this.searchData.name = '';this.searchData.voicePlatform = '';this.init();}, searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;this.init();}, handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;this.searchData.page = 1;this.init();}, handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;this.init();}, addFun: function addFun() {// 新增
      this.title = '新增';this.newadd = true;},
    closeDiglog: function closeDiglog() {// 关闭弹出层
      this.$refs['addForm'].resetFields();
      this.cleanData();
      this.newadd = false;
      this.newadd2 = false;
    },
    updateMenu: function updateMenu(item) {// 修改操作
      this.title = '修改';
      var self = this;
      self.newadd = true;
      self.addData = {
        id: item.id,
        deviceTypeCode: item.deviceTypeCode,
        isEnabled: item.isEnabled + '',
        slot: item.slot,
        standardSlot: item.standardSlot,
        remark: item.remark };

    },
    onSubmit: function onSubmit() {// 新增提交操作
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.postData('/api/voiceIntent', self.addData, function (res) {
            self.$message({
              message: '添加成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    delMenu: function delMenu(delId) {// 删除操作
      var self = this;
      self.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.delData('/api/voiceApp/' + delId, {}, function (res) {
          self.$message({
            message: '删除成功!',
            type: 'success' });

          self.searchData.page = 1;
          self.init();
        });
      }).catch(function () {});
    },
    onCencal: function onCencal() {// 关闭弹出框
      this.$refs.addForm.resetFields();
      this.cleanData();
      this.newadd = false;
    },
    cleanData: function cleanData() {// 清理输入的数据
      this.addData = {
        id: '',
        slot: '',
        deviceTypeCode: '',
        isEnabled: '1',
        standardSlot: '',
        remark: '' };

    },
    openOrgDialog: function openOrgDialog(robotId) {
      var self = this;
      self.robotId = robotId;
      self.getIns(robotId);
      self.getOrganziationList();
      self.modOrg = true;
    },
    checkFn: function checkFn(node, data) {
      var currKey = node.id;
      this.$refs.orgTree.setCheckedKeys([currKey]);
      this.insId = currKey;
    } } };exports.default = _default;